module.exports = __webpack_public_path__ + "img/default-product.8d0c7f00.jpg";